<ngx-skeleton-loader
  id="skeleton"
  class="{{ flexDirection }}"
  [animation]="animation"
  [count]="count"
  [appearance]="appearance"
  [theme]="themeSkeleton"
  [style.gap]="separation + 'px'"></ngx-skeleton-loader>
